"use client"

import { ArrowRight } from "lucide-react"
import { useReveal } from "@/components/marketing/landing-v2/useReveal"
import type { Landing2Copy } from "@/lib/landing-v2/copy"

export function ClosingBand({
  copy,
  onCta,
}: {
  copy: Landing2Copy
  onCta: () => void
}) {
  const ref = useReveal<HTMLDivElement>()

  return (
    <section className="l2-section l2-section-tight">
      <div className="l2-container">
        <div className="l2-closing" ref={ref}>
          <div>
            <h2 className="l2-h3">{copy.closing.title}</h2>
            <p className="l2-closing-body">{copy.closing.body}</p>
          </div>
          <button type="button" className="l2-button l2-button-lg" onClick={onCta}>
            {copy.nav.cta}
            <ArrowRight size={17} strokeWidth={2.2} />
          </button>
        </div>
      </div>
    </section>
  )
}
